import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { UpdateAllocationPayload } from '@/services/allocation'
import type { AllocationDetailed } from '@/types'
import { readFormValues } from '@/helpers/form-values.helper'
import { useFormChanges } from '@/hooks/use-form-changes'

interface EdicaoAlocacaoFormValues {
  name: string
}

export interface DialogEdicaoAlocacaoProps {
  item: AllocationDetailed
  isOpen: boolean
  onClose: () => void
  onSubmit: (allocationId: number, allocation: UpdateAllocationPayload) => void
}

function DialogEdicaoAlocacao({ item, isOpen, onClose, onSubmit }: DialogEdicaoAlocacaoProps) {
  const { formProps, hasChanges } = useFormChanges()

  const submitAndCloseDialog = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!hasChanges(event.currentTarget)) {
      onClose()
      return
    }
    const newAgencyData = new FormData(event.currentTarget)
    const entries = readFormValues<EdicaoAlocacaoFormValues>(newAgencyData)

    onSubmit(item.id, {
      name: entries.name
    })

    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[595px]">
        <form {...formProps} onSubmit={submitAndCloseDialog}>
          <DialogHeader>
            <DialogTitle>Editar Alocação</DialogTitle>
          </DialogHeader>

          <div className="flex w-full flex-col space-y-4 pt-4">
            <div className="space-y-1.5">
              <Label htmlFor="name">Nome</Label>
              <Input
                // disabled
                required
                id="name"
                type="text"
                name="name"
                defaultValue={item.name}
                placeholder="Insira o nome da alocação"
                maxLength={80}
              />
            </div>
          </div>

          <DialogFooter className="gap-x-4 pt-6">
            <Button type="button" onClick={onClose} variant="ghost" size="sm">
              Cancelar
            </Button>
            <Button
              type="submit"
              size="sm"
              className="bg-green-600 text-white hover:bg-green-700"
            >
              Salvar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export { DialogEdicaoAlocacao }
